var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('h3',[_vm._v(_vm._s(_vm.dateTitle))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.dateMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }